import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.632 15.77q0-1.7.391-2.6.39-.903 1.634-2 .967-.863 1.466-1.563.5-.701.499-1.59 0-1.179-.803-1.96t-2.21-.78q-1.286 0-2 .688a4.8 4.8 0 0 0-1.087 1.537L7.697 6.7a5.7 5.7 0 0 1 1.82-2.395q1.236-.96 3.092-.959 2.422 0 3.73 1.366 1.306 1.366 1.306 3.244 0 1.173-.508 2.07-.51.897-1.544 1.868-1.302 1.194-1.612 1.884t-.311 1.991zm.976 5.73q-.613 0-1.056-.443A1.44 1.44 0 0 1 11.108 20q0-.614.444-1.057a1.44 1.44 0 0 1 1.056-.443q.615 0 1.057.443.444.444.444 1.057t-.444 1.057a1.44 1.44 0 0 1-1.056.443" }, null, -1)
  ])))
}
export default { render: render }